module.exports = __webpack_public_path__ + "img/657.a8bc2a58.png";